import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export type LocationAddressFormValue = {
  street?: string | null;
  streetNumber?: string | null;
  postalCode?: string | null;
  city?: string | null;
  lat?: number | null;
  lon?: number | null;
};

export function hasValidCoordinates(lat?: number | null, lon?: number | null): boolean {
  return typeof lat === 'number' && Number.isFinite(lat) && typeof lon === 'number' && Number.isFinite(lon);
}

export function hasAnyCoordinateValue(lat?: number | null, lon?: number | null): boolean {
  return (typeof lat === 'number' && Number.isFinite(lat)) || (typeof lon === 'number' && Number.isFinite(lon));
}

export function hasAnyAddressPart(address: Partial<LocationAddressFormValue>): boolean {
  return [address.street, address.streetNumber, address.postalCode, address.city].some(
    (value) => `${value ?? ''}`.trim().length > 0,
  );
}

export function getLocationAddressFormValue(control: AbstractControl): LocationAddressFormValue {
  if (!(control instanceof FormGroup)) {
    return {};
  }

  return {
    street: control.get('street')?.value,
    streetNumber: control.get('streetNumber')?.value,
    postalCode: control.get('postalCode')?.value,
    city: control.get('city')?.value,
    lat: control.get('lat')?.value,
    lon: control.get('lon')?.value,
  };
}

export function locationAddressOrCoordinatesValidator(isAddressNotResolved: () => boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = getLocationAddressFormValue(control);

    if (hasValidCoordinates(value.lat, value.lon)) {
      return null;
    }

    if (!hasAnyAddressPart(value)) {
      return { locationRequired: true };
    }

    return isAddressNotResolved() ? { notResolved: true } : null;
  };
}
